/*

This is the client-specific Tailwind configuration file. Any settings added
here will be added to the default options, but will override any settings
with the same name.

*/

const brandColors = require('./tailwind.colors.client.js');

module.exports = {
    theme: {
        borderRadius: {},
        borderWidth: {},
        boxShadow: {},
        colors: brandColors,
        fontFamily: {
            default: 'ProximaNova-Regular',
            proximaBold: 'ProximaNova-Bold',
            heading: 'Geometric Slabserif',
            accent: 'GeometricSlab703TL-XtraBd',
            proximaLight: 'ProximaNova-Light',
        },
        fontSize: {},
        height: {},
        letterSpacing: {},
        lineHeight: {},
        margin: {},
        maxHeight: {},
        maxWidth: {},
        minHeight: {},
        minWidth: {},
        opacity: {},
        padding: {},
        width: {},
        skewY: {},
        zIndex: {},
    },

    variants: {},

    plugins: [],
};
